export const ObjectsService = {
  getData() {
    return [
      {
        assetName: 'ГТРК «Башкортостан»',
        assetType: 'Прочие объекты',
        address: 'Уфа, ул. Гафури, д. 9/1',
        active: true,
        description: 'Описание 1',
        id: 0,
        сharacteristics: []
      },
      {
        assetName: 'РТРС',
        assetType: 'Прочие объекты',
        address: 'Уфа, ул. Рихарда Зорге дом 67/5',
        active: false,
        description: 'Описание 2',
        id: 1,
        сharacteristics: []
      },
      {
        assetName: 'Стадион «Нефтяник» (футбол)',
        assetType: 'Прочие объекты',
        address: 'Уфа, ул. Комарова, д.9',
        active: true,
        description: 'Описание 3',
        id: 2,
        сharacteristics: []
      },
      {
        assetName: 'УСА «Уфа-Арена» (хоккей)',
        assetType: 'Прочие объекты',
        address: 'Уфа, ул.Ленина, д.114',
        active: false,
        description: 'Описание 4',
        id: 3,
        сharacteristics: []
      },
      {
        assetName: 'УД Уфа (Ленина, 30)',
        assetType: 'Прочие объекты',
        address: 'г. Уфа, ул. Ленина, 30',
        active: true,
        description: 'Описание 5',
        id: 4,
        сharacteristics: []
      },
      {
        assetName: 'УД Уфа (Российская, д. 19)',
        assetType: 'Прочие объекты',
        address: 'Республика Башкортостан, г. Уфа, ул. Российская, д. 19',
        active: false,
        description: 'Описание 6',
        id: 5,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Вятка»',
        assetType: 'Прочие объекты',
        address: 'Киров, ул. Урицкого, д. 36',
        active: true,
        description: 'Описание 7',
        id: 6,
        сharacteristics: []
      },
      {
        assetName: 'МСС-122 Киров (ул.Московская, 20)',
        assetType: 'Прочие объекты',
        address: 'г. Киров, ул. Московская, д. 20',
        active: false,
        description: 'Описание 8',
        id: 7,
        сharacteristics: []
      },
      {
        assetName: 'ТРП-9Д (Д. Константиново)',
        assetType: 'Прочие объекты',
        address:
          'Нижегородская обл., р. п. Дальнее Константиново, ул. Советская, 189а',
        active: true,
        description: 'Описание 9',
        id: 8,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Нижний Новгород»',
        assetType: 'Прочие объекты',
        address: 'Нижний Новгород, ул. Белинского, д. 9А',
        active: false,
        description: 'Описание 10',
        id: 9,
        сharacteristics: []
      },
      {
        assetName: 'РТРС',
        assetType: 'Прочие объекты',
        address: 'Нижний Новгород, ул. Белинского 9а',
        active: true,
        description: 'Описание 11',
        id: 10,
        сharacteristics: []
      },
      {
        assetName: 'КРК «Нагорный» (хоккей, баскетбол)',
        assetType: 'Прочие объекты',
        address: 'Нижний новгород, ул.Гагарина, 29',
        active: false,
        description: 'Описание 12',
        id: 11,
        сharacteristics: []
      },
      {
        assetName: '"Арена ""Нижний Новгород"" (футбол)"',
        assetType: 'Прочие объекты',
        address: 'Нижний новгород, ул.Бетанкура, д.1А',
        active: true,
        description: 'Описание 13',
        id: 12,
        сharacteristics: []
      },
      {
        assetName: '"ФОК ""Мещерский"" (баскетбол)"',
        assetType: 'Прочие объекты',
        address: 'Нижний новгород, ул.Карла Маркса, 21',
        active: false,
        description: 'Описание 14',
        id: 13,
        сharacteristics: []
      },
      {
        assetName: 'УД Нижний Новгород (пр.Гагарина, 11/11)',
        assetType: 'Прочие объекты',
        address: 'г. Нижний Новгород, пр. Гагарина, д. 11-11',
        active: true,
        description: 'Описание 15',
        id: 14,
        сharacteristics: []
      },
      {
        assetName: 'Гоночная трасса Нижегородское кольцо',
        assetType: 'Прочие объекты',
        address:
          'Нижегородская обл., Богородский р-н.,  д. Березовка, д. 1, 37-й км трассы Нижний Новгород - Касимов Р-125',
        active: false,
        description: 'Описание 16',
        id: 15,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Оренбург»',
        assetType: 'Прочие объекты',
        address: 'Оренбург, переулок Телевизионный д.3',
        active: true,
        description: 'Описание 17',
        id: 16,
        сharacteristics: []
      },
      {
        assetName: 'РТРС',
        assetType: 'Прочие объекты',
        address: 'Оренбург, пер.Телевизионный д.3',
        active: false,
        description: 'Описание 18',
        id: 17,
        сharacteristics: []
      },
      {
        assetName: '"Стадион ""Газовик"" (футбол)"',
        assetType: 'Прочие объекты',
        address: 'Оренбург, Цветной бульвар, д.31',
        active: true,
        description: 'Описание 19',
        id: 18,
        сharacteristics: []
      },
      {
        assetName: 'УД Оренбург (ул.Терешковой,10)',
        assetType: 'Прочие объекты',
        address: 'г. Оренбург, ул., Терешковой, д. 10',
        active: false,
        description: 'Описание 20',
        id: 19,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Пенза»',
        assetType: 'Прочие объекты',
        address: 'Пенза, ул. Лермонтова, д. 39',
        active: true,
        description: 'Описание 21',
        id: 20,
        сharacteristics: []
      },
      {
        assetName: 'МСС-31 Пенза (ул.Кирова, 54)',
        assetType: 'Прочие объекты',
        address: 'г. Пенза, ул. Кирова, д. 54',
        active: false,
        description: 'Описание 22',
        id: 21,
        сharacteristics: []
      },
      {
        assetName: 'ТРП-3М (Мокшан)',
        assetType: 'Прочие объекты',
        address: 'Пензенская область, р.п. Мокшан, ул. Энгельса, д. 51а',
        active: true,
        description: 'Описание 23',
        id: 22,
        сharacteristics: []
      },
      {
        assetName: 'ТРП-5Ч (Чишмы)',
        assetType: 'Прочие объекты',
        address: 'Республика Башкортостан, п. Чишмы, ул. Связистов, д. 1',
        active: false,
        description: 'Описание 24',
        id: 23,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Самара»',
        assetType: 'Прочие объекты',
        address: 'Самара, ул. Советской Армии, дом 205',
        active: true,
        description: 'Описание 25',
        id: 24,
        сharacteristics: []
      },
      {
        assetName: 'РТРС',
        assetType: 'Прочие объекты',
        address: 'Самара, ул. Советской Армии, 205',
        active: false,
        description: 'Описание 26',
        id: 25,
        сharacteristics: []
      },
      {
        assetName: '"Стадион ""Металлург"" (футбол)"',
        assetType: 'Прочие объекты',
        address: 'Самара, ул.Строителей, д.1',
        active: true,
        description: 'Описание 27',
        id: 26,
        сharacteristics: []
      },
      {
        assetName: '"Стадион ""Самара-Арена"" (футбол)"',
        assetType: 'Прочие объекты',
        address: 'Самара, ул.Демократическая, д.57',
        active: false,
        description: 'Описание 28',
        id: 27,
        сharacteristics: []
      },
      {
        assetName: 'УД Самара (Мичурина, 54)',
        assetType: 'Прочие объекты',
        address: ' г. Самара, ул. Мичурина, 54',
        active: true,
        description: 'Описание 29',
        id: 28,
        сharacteristics: []
      },
      {
        assetName: 'УД Самара (Садовая, 292)',
        assetType: 'Прочие объекты',
        address: 'г. Самара, ул. Садовая, 292',
        active: false,
        description: 'Описание 30',
        id: 29,
        сharacteristics: []
      },
      {
        assetName: 'ТРП-4 (Шигоны)',
        assetType: 'Прочие объекты',
        address: 'Самарская область, с. Шигоны, ул. Кооперативная, 1б-3',
        active: true,
        description: 'Описание 31',
        id: 30,
        сharacteristics: []
      },
      {
        assetName: 'ЛДС «Лада-Арена» (хоккей)',
        assetType: 'Прочие объекты',
        address: 'Тольятти, ул.Ботаническая, 5',
        active: false,
        description: 'Описание 32',
        id: 31,
        сharacteristics: []
      },
      {
        assetName: '"Универсальный спортивный комплекс ""Олимп"""',
        assetType: 'Прочие объекты',
        address: 'Тольятти, Приморский бульвар, д.49',
        active: true,
        description: 'Описание 33',
        id: 32,
        сharacteristics: []
      },
      {
        assetName: 'УД Тольятти (Московский проспект, д.21)',
        assetType: 'Прочие объекты',
        address: 'г. Тольятти, АТС-37, (ТЗУС), Московский проспект, д.21',
        active: false,
        description: 'Описание 34',
        id: 33,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Саратов»',
        assetType: 'Прочие объекты',
        address: 'Саратов, ул. 2-я Садовая, д.7',
        active: true,
        description: 'Описание 35',
        id: 34,
        сharacteristics: []
      },
      {
        assetName: 'РТРС',
        assetType: 'Прочие объекты',
        address: 'Саратов, Лысая Гора, б/н',
        active: false,
        description: 'Описание 36',
        id: 35,
        сharacteristics: []
      },
      {
        assetName: '"ДС ""Кристалл"" (баскетбол)"',
        assetType: 'Прочие объекты',
        address: 'Саратов, ул. Чернышевского, д.63',
        active: true,
        description: 'Описание 37',
        id: 36,
        сharacteristics: []
      },
      {
        assetName: 'УД Саратов (пер. Мирный, д. 11/13)',
        assetType: 'Прочие объекты',
        address: 'г. Саратов, пер. Мирный, д. 11/13 здание АМТС ',
        active: false,
        description: 'Описание 38',
        id: 37,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Волга»',
        assetType: 'Прочие объекты',
        address: 'Ульяновск, пр-т Нариманова, д.62',
        active: true,
        description: 'Описание 39',
        id: 38,
        сharacteristics: []
      },
      {
        assetName: 'МСС-41 Ульяновск (Льва Толстого, 95)',
        assetType: 'Прочие объекты',
        address: 'г. Ульяновск, ул. Льва Толстого, д. 95, МСС-41',
        active: false,
        description: 'Описание 40',
        id: 39,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Марий Эл»',
        assetType: 'Прочие объекты',
        address: 'Йошкар-Ола, ул. Машиностроителей, д. 7а',
        active: true,
        description: 'Описание 41',
        id: 40,
        сharacteristics: []
      },
      {
        assetName: 'МСС-101 Йошкар-Ола (ул.Пушкина, 14)',
        assetType: 'Прочие объекты',
        address: 'г. Йошкар-Ола, ул. Пушкина, д. 14',
        active: false,
        description: 'Описание 42',
        id: 41,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Мордовия»',
        assetType: 'Прочие объекты',
        address: 'Саранск, ул. Докучаева, д. 29',
        active: true,
        description: 'Описание 43',
        id: 42,
        сharacteristics: []
      },
      {
        assetName: '"Стадион ""Мордовия-Арена"" (футбол, МК из Москвы)"',
        assetType: 'Прочие объекты',
        address: 'Саранск, Волгоградская, д.1',
        active: false,
        description: 'Описание 44',
        id: 43,
        сharacteristics: []
      },
      {
        assetName: 'МСС-32 Саранск (ул.Комунистическая, 34)',
        assetType: 'Прочие объекты',
        address: 'г. Саранск, ул. Коммунистическая, д. 34',
        active: true,
        description: 'Описание 45',
        id: 44,
        сharacteristics: []
      },
      {
        assetName: 'ГТРК «Татарстан»',
        assetType: 'Вышка',
        address: 'Казань, ул. Ш. Усманова, д. 9',
        active: false,
        description: 'Описание 46',
        id: 45,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Вышка',
        address: 'Казань, ул.Можайского, д.6',
        active: true,
        description: 'Описание 47',
        id: 46,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ЛДС «Татнефть Арена» (КХЛ)',
        assetType: 'Вышка',
        address: 'Казань, ул.Чистопольская, д.42',
        active: false,
        description: 'Описание 48',
        id: 47,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Стадион «Казань Арена» (РФПЛ)',
        assetType: 'Вышка',
        address: 'Казань, Проспект Ямашева, д.115а',
        active: true,
        description: 'Описание 49',
        id: 48,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Баскет-Холл (Баскетбол)',
        assetType: 'Вышка',
        address: 'Казань, ул. Спартаковская, д.1',
        active: false,
        description: 'Описание 50',
        id: 49,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Воллейбольный центр ""Санкт-Петербург"""',
        assetType: 'Вышка',
        address: 'Казань, ул.Мидхата Булатова, д.1',
        active: true,
        description: 'Описание 51',
        id: 50,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Казань (ул.Можайского, 6)',
        assetType: 'Вышка',
        address: 'г. Казань, ул. Можайского, д. 6',
        active: false,
        description: 'Описание 52',
        id: 51,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'СКК «Нефтехимик» (хоккей)',
        assetType: 'Вышка',
        address: 'Нижнекамск, Республика Татарстан, ул .30 лет Победы, д.8',
        active: true,
        description: 'Описание 53',
        id: 52,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-21 (Апастово)',
        assetType: 'Вышка',
        address: 'Республика Татарстан, пгт. Апастово, ул. Заводская, д. 11',
        active: false,
        description: 'Описание 54',
        id: 53,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-14Т (Тюлячи)',
        assetType: 'Вышка',
        address:
          'Республика Татарстан, Тюлячинский район, с. Тюлячи, ул. Советская, д. 1а',
        active: true,
        description: 'Описание 55',
        id: 54,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Удмуртия»',
        assetType: 'Вышка',
        address: 'Ижевск,  ул.Песочная 13',
        active: false,
        description: 'Описание 56',
        id: 55,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Вышка',
        address: 'Ижевск, ул. Песочная, 15',
        active: true,
        description: 'Описание 57',
        id: 56,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Ижевск (ул.Карла Маркса,206)',
        assetType: 'Вышка',
        address: 'г. Ижевск, ул. Карла Маркса, 206',
        active: false,
        description: 'Описание 58',
        id: 57,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-16М (М. Пурга)',
        assetType: 'Вышка',
        address:
          'Удмуртская Республика, Малопургинский район, с. Малая Пурга, ул. Колхозная, д. 113',
        active: true,
        description: 'Описание 59',
        id: 58,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Чувашия»',
        assetType: 'Вышка',
        address: 'Чебоксары, ул. Николаева, д. 10',
        active: false,
        description: 'Описание 60',
        id: 59,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: ' МСС-82 Чебоксары (пр.Ленина, 2)',
        assetType: 'Вышка',
        address: 'г. Чебоксары, пр. Ленина, д. 2',
        active: true,
        description: 'Описание 61',
        id: 60,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Белогорск (Кирова 257)',
        assetType: 'Вышка',
        address: 'Амурская обл.,  г. Белогорск, ул. Кирова, д. 257',
        active: false,
        description: 'Описание 62',
        id: 61,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Амур»',
        assetType: 'Вышка',
        address: 'Благовещенск, пер. Св. Иннокентия, д. 15',
        active: true,
        description: 'Описание 63',
        id: 62,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Благовещенск (ул.Амурская 205-211)',
        assetType: 'Вышка',
        address: 'г. Благовещенск, ул. Амурская, д. 205',
        active: false,
        description: 'Описание 64',
        id: 63,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-18С (Сковордино)',
        assetType: 'Вышка',
        address: 'Амурская область, г. Сковородино, ул. Победы, д. 4',
        active: true,
        description: 'Описание 65',
        id: 64,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-18АТ (Тында)',
        assetType: 'Вышка',
        address: 'Амурская область, г. Тында, Южная промплощадка ТРП-18АТ',
        active: false,
        description: 'Описание 66',
        id: 65,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Камчатка»',
        assetType: 'Вышка',
        address: 'Петропавловск-Камчатский, ул. Советская, 62',
        active: true,
        description: 'Описание 67',
        id: 66,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Петропавловск-Камчатский (Владивостокская, д. 5)',
        assetType: 'Вышка',
        address: 'г. Петропавловск-Камчатский, ул. Владивостокская, д. 5',
        active: false,
        description: 'Описание 68',
        id: 67,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Магадан»',
        assetType: 'Вышка',
        address: 'Магадан, пл.Комсомольская, д.3',
        active: true,
        description: 'Описание 69',
        id: 68,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Магадан (Пролетарская 10)',
        assetType: 'Вышка',
        address: ' г. Магадан, ул. Пролетарская, д. 10',
        active: false,
        description: 'Описание 70',
        id: 69,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Владивосток»',
        assetType: 'Вышка',
        address: 'Владивосток, ул. Уборевича, 20А',
        active: true,
        description: 'Описание 71',
        id: 70,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'КСК «Фетисов Арена»',
        assetType: 'Вышка',
        address: 'Владивосток, Маковского, 284',
        active: false,
        description: 'Описание 72',
        id: 71,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Владивосток (Алеутская 45а)',
        assetType: 'Вышка',
        address: 'г. Владивосток, ул. Алеутская, д. 45а.',
        active: true,
        description: 'Описание 73',
        id: 72,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Владивосток (Комарова 36)',
        assetType: 'Вышка',
        address: 'г. Владивосток, Комарова, 36',
        active: false,
        description: 'Описание 74',
        id: 73,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТрП-36 БС Оха ',
        assetType: 'Вышка',
        address: 'Сахалинская область, г. Оха, ул. Блюхера, д. 9',
        active: true,
        description: 'Описание 75',
        id: 74,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Сахалин»',
        assetType: 'Вышка',
        address: 'Южно-Сахалинск, ул. Комсомольская, д 211',
        active: false,
        description: 'Описание 76',
        id: 75,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Южно-Сахалинск (ул. Ленина, 220)',
        assetType: 'Вышка',
        address: 'Сахалинская область, г. Южно-Сахалинск, ул. Ленина, д. 220',
        active: true,
        description: 'Описание 77',
        id: 76,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Саха»',
        assetType: 'Вышка',
        address: 'Якутск, ул. Орджоникидзе, д. 48',
        active: false,
        description: 'Описание 78',
        id: 77,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Якутск (ул. Гоголя 1)',
        assetType: 'Вышка',
        address: 'Республика Саха (Якутия), г. Якутск, ул. Гоголя, д. 1',
        active: true,
        description: 'Описание 79',
        id: 78,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Чукотка»',
        assetType: 'Вышка',
        address: 'Анадырь, ул. Ленина, д. 18А',
        active: false,
        description: 'Описание 80',
        id: 79,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД  Анадырь, (Ленина 20)',
        assetType: 'Вышка',
        address: 'г. Анадырь, ул. Ленина, д. 20',
        active: true,
        description: 'Описание 81',
        id: 80,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Бира»',
        assetType: 'Вышка',
        address:
          'Еврейская автономная область, Биробиджан, ул.Октябрьская, д.15',
        active: false,
        description: 'Описание 82',
        id: 81,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Биробиджан (Проспект 60 лет СССР 16)',
        assetType: 'Вышка',
        address:
          'Еврейская автономная область, г. Биробиджан, Проспект 60 лет СССР,16',
        active: true,
        description: 'Описание 83',
        id: 82,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-19АПС (Комсомольская)',
        assetType: 'Вышка',
        address: 'Хабаровский край, г. Комсомольск-на-Амуре, ПС Комсомольская',
        active: false,
        description: 'Описание 84',
        id: 83,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Дальневосточная»',
        assetType: 'Вышка',
        address: 'Хабаровск, ул. Ленина, 71',
        active: true,
        description: 'Описание 85',
        id: 84,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'СЗК «Платинум Арена» (хоккей)',
        assetType: 'Вышка',
        address: 'Хабаровск, ул. Дикопольцева, д. 12',
        active: false,
        description: 'Описание 86',
        id: 85,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Стадион им.Ленина (футбол)',
        assetType: 'Вышка',
        address: 'Хабаровск, ул.Советская, д.1, корп. 2',
        active: true,
        description: 'Описание 87',
        id: 86,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Арена ""Ерофей"" (хоккей с мячом)"',
        assetType: 'Вышка',
        address: 'Хабаровск, ул.Морозова Павла Леонтьевича, д.83',
        active: false,
        description: 'Описание 88',
        id: 87,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Хабаровск (К.Маркса, 58)',
        assetType: 'Вышка',
        address: 'г. Хабаровск, ул. Карла Маркса, д. 58',
        active: true,
        description: 'Описание 89',
        id: 88,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-30С (Селихино)',
        assetType: 'Вышка',
        address: 'Хабаровский край, с. Селихино, ул. Комсомольская, д. 5а',
        active: false,
        description: 'Описание 90',
        id: 89,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-20 (Князе-Волконское)',
        assetType: 'Вышка',
        address:
          'Хабаровский край, с. Князе-Волконское, ул. Набережная, д. 50а',
        active: true,
        description: 'Описание 91',
        id: 90,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ЦКС',
        assetType: 'Вышка',
        address: 'Хабаровск, 21й км Сарапульского шоссе 1 этаж, пом. 21',
        active: false,
        description: 'Описание 92',
        id: 91,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Аппаратная РТРС',
        assetType: 'Вышка',
        address: 'Хабаровск, ул. Карла Маркса, д.58  ',
        active: true,
        description: 'Описание 93',
        id: 92,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Поморье»',
        assetType: 'Вышка',
        address: 'Архангельск, пр. Троицкий, д. 73',
        active: false,
        description: 'Описание 94',
        id: 93,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Архангельск (Карла Либкнехта 23)',
        assetType: 'Вышка',
        address: 'г. Архангельск, ул. Карла Либкнехта, д. 23, корп. 1',
        active: true,
        description: 'Описание 95',
        id: 94,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Вологда»',
        assetType: 'Вышка',
        address: 'Вологда, ул. Предтеченская, д. 32',
        active: false,
        description: 'Описание 96',
        id: 95,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД-151В Вологда (Зосимовская, 28)',
        assetType: 'Вышка',
        address: 'г. Вологда, ул. Зосимовская, д. 28',
        active: true,
        description: 'Описание 97',
        id: 96,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-15Г (Грязовец)',
        assetType: 'Вышка',
        address: 'Вологодская область, г. Грязовец, 2-й пер. Северный, д. 42',
        active: false,
        description: 'Описание 98',
        id: 97,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ЛД ""Алмаз""  (Ледовый дворец) (хоккей)"',
        assetType: 'Вышка',
        address: 'Вологодская обл., Череповец, Октябрьский проспект, д.70',
        active: true,
        description: 'Описание 99',
        id: 98,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД  Череповец (Советский, д. 29)',
        assetType: 'Вышка',
        address: 'Вологодская обл., г. Череповец, пр. Советский, д. 29',
        active: false,
        description: 'Описание 100',
        id: 99,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК/ Телестанция «Канал 12»',
        assetType: 'Вышка',
        address: 'Вологодская обл. Череповец, ул. Ленина, д. 151',
        active: true,
        description: 'Описание 101',
        id: 100,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Калининград (Ленинский пр-т, д. 32)',
        assetType: 'Вышка',
        address: 'г. Калининград, Ленинский пр-т, д. 32',
        active: false,
        description: 'Описание 102',
        id: 101,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Калининград»',
        assetType: 'Вышка',
        address: 'Калининград, ул.Клиническая д.19',
        active: true,
        description: 'Описание 103',
        id: 102,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Вышка',
        address: 'Калининград, Советский проспект 40-а',
        active: false,
        description: 'Описание 104',
        id: 103,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ДС Янтарный (воллейбол)',
        assetType: 'Вышка',
        address: 'Калининград, ул.Согласия, д.39',
        active: true,
        description: 'Описание 105',
        id: 104,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Калининград-Арена"" (футбол)"',
        assetType: 'Вышка',
        address: 'Калининград, Солнечный бульвар, д.25',
        active: false,
        description: 'Описание 106',
        id: 105,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-6К (Кемь)',
        assetType: 'Вышка',
        address: 'Республика Карелия, г. Кемь, ул. Полярная, д. 12',
        active: true,
        description: 'Описание 107',
        id: 106,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-2К (Кончезеро)',
        assetType: 'Вышка',
        address: 'Республика Карелия, с. Кончезеро, ул. Юности, д. 5',
        active: false,
        description: 'Описание 108',
        id: 107,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Карелия»',
        assetType: 'Вышка',
        address: 'Петрозаводск, ул. Пирогова, 2',
        active: true,
        description: 'Описание 109',
        id: 108,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС Петрозаводск (ул.Горького,4)',
        assetType: 'Вышка',
        address: 'г. Петрозаводск, ул. М. Горького, д. 4',
        active: false,
        description: 'Описание 110',
        id: 109,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Коми Гор»',
        assetType: 'Вышка',
        address: 'Сыктывкар, Октябрьский пр-т,д.164 ',
        active: true,
        description: 'Описание 111',
        id: 110,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Сыктывкар (Октябрьский пр-кт, д. 162)',
        assetType: 'Вышка',
        address: ' г. Сыктывкар, Октябрьский пр-кт, д. 162',
        active: false,
        description: 'Описание 112',
        id: 111,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Мурман»',
        assetType: 'Вышка',
        address: 'Мурманск , ул. Шолохова , д 50',
        active: true,
        description: 'Описание 113',
        id: 112,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД-101М Мурманск (Шолохова, 34)',
        assetType: 'Вышка',
        address: 'г. Мурманск, ул. Шолохова, д. 34',
        active: false,
        description: 'Описание 114',
        id: 113,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-14И (Иссад)',
        assetType: 'Вышка',
        address: 'ЛО, Волховский р-н, д. Иссад, Мкр. ЛТЦ-4, д. 5',
        active: true,
        description: 'Описание 115',
        id: 114,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-14Л (Любань)',
        assetType: 'Вышка',
        address:
          'Ленинградская обл., Тосненский р-н, г. Любань, Загородное ш., д. 36 «а»',
        active: false,
        description: 'Описание 116',
        id: 115,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Санкт-Петербург»',
        assetType: 'Вышка',
        address: 'Санкт-Петербург, Набережная реки Карповки 43.',
        active: true,
        description: 'Описание 117',
        id: 116,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Вышка',
        address: 'Сакнт-Петербург, ул. Академика Павлова д.3.',
        active: false,
        description: 'Описание 118',
        id: 117,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '" ""Сибур Арена"""',
        assetType: 'Вышка',
        address: 'Санкт-Петербург, Футбольная аллея, д.8,',
        active: true,
        description: 'Описание 119',
        id: 118,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ДС «Юбилейный»',
        assetType: 'Вышка',
        address: 'Санкт-Петербург, пр. Добролюбова, д.18',
        active: false,
        description: 'Описание 120',
        id: 119,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Стадион “Зенит Арена”:',
        assetType: 'Вышка',
        address: 'Санкт-Петербург, Футбольная аллея, д.1',
        active: true,
        description: 'Описание 121',
        id: 120,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Ледовый дворец «Санкт-Петербург»',
        assetType: 'Абонент',
        address: 'Санкт-Петербург, пр. Пятилеток д.1',
        active: false,
        description: 'Описание 122',
        id: 121,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-32 Санкт-Петербург (Синопская  14)',
        assetType: 'Абонент',
        address: 'г. Санкт-Петербург, Синопская наб., д. 14',
        active: true,
        description: 'Описание 123',
        id: 122,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Петрозаводская 8/АТС-230',
        assetType: 'Абонент',
        address: 'г. С-Петербург, ул. Петрозаводская, д.8/АТС-230',
        active: false,
        description: 'Описание 124',
        id: 123,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ТРК/ ООО ""ТВ Купол"" "',
        assetType: 'Абонент',
        address:
          'Санкт-Петербург, Петроградская набережная, дом 18, литера «А» ',
        active: true,
        description: 'Описание 125',
        id: 124,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК/ Аппаратная НТВ ',
        assetType: 'Абонент',
        address: 'Санкт-Петербург, ул. Ак. Павлова д.12\\14 ',
        active: false,
        description: 'Описание 126',
        id: 125,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК / ЦА  ТРК «5 канал»',
        assetType: 'Абонент',
        address: 'Санкт-Петербург, ул. Чапыгина, д. 5',
        active: true,
        description: 'Описание 127',
        id: 126,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Петровский"""',
        assetType: 'Абонент',
        address: 'Санкт-Петербург, Петровский остров, д.2Г',
        active: false,
        description: 'Описание 128',
        id: 127,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Славия»',
        assetType: 'Абонент',
        address: 'Великий Новгород, ул. Большая Московская, д.106',
        active: true,
        description: 'Описание 129',
        id: 128,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Великий Новгород (Б.Московская, 94а)',
        assetType: 'Абонент',
        address: 'г. Великий Новгород, ул. Большая Московская, д. 94А',
        active: false,
        description: 'Описание 130',
        id: 129,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-29П (Подберезье)',
        assetType: 'Абонент',
        address: 'Новгородская обл., д. Подберезье, ул. Связистов, д. 1А',
        active: true,
        description: 'Описание 131',
        id: 130,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Псков» ',
        assetType: 'Абонент',
        address: 'Псков, Рижский проспект, д. 71',
        active: false,
        description: 'Описание 132',
        id: 131,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Псков (ул.Печорская, 4)',
        assetType: 'Абонент',
        address: 'Псковская область, г. Псков, ул. Печорская, д. 4',
        active: true,
        description: 'Описание 133',
        id: 132,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Алтай»',
        assetType: 'Абонент',
        address: 'Барнаул, Змеиногорский тракт, д. 27',
        active: false,
        description: 'Описание 134',
        id: 133,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Абонент',
        address: 'Барнаул, Змеиногорский тракт, 29а, ',
        active: true,
        description: 'Описание 135',
        id: 134,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Барнаул (Димитрова 62А)',
        assetType: 'Абонент',
        address: 'г. Барнаул, ул. Димитрова, д. 62 А',
        active: false,
        description: 'Описание 136',
        id: 135,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Горный Алтай»',
        assetType: 'Абонент',
        address: 'Республика Алтай, Горно-Алтайск, пр. Коммунистический, 37',
        active: true,
        description: 'Описание 137',
        id: 136,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Горно-Алтайск (ул. Чорос-Гуркина 37)',
        assetType: 'Абонент',
        address: 'Республика Алтай, г. Горно-Алтайск, ул. Чорос-Гуркина, д. 37',
        active: false,
        description: 'Описание 138',
        id: 137,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-16Т (Турунтаево)',
        assetType: 'Абонент',
        address: 'Республика Бурятия, с. Турунтаево, ул. 16 квартал, д. 1',
        active: true,
        description: 'Описание 139',
        id: 138,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Бурятия»',
        assetType: 'Абонент',
        address: 'Улан-Удэ, ул. Бабушкина, 23Б',
        active: false,
        description: 'Описание 140',
        id: 139,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Улан-Удэ (Жуковского, д.1 )',
        assetType: 'Абонент',
        address: 'г. Улан-Удэ, ул. Жуковского, д. 1',
        active: true,
        description: 'Описание 141',
        id: 140,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Чита»',
        assetType: 'Абонент',
        address: 'Чита, ул. Бутина, 86',
        active: false,
        description: 'Описание 142',
        id: 141,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-171 Чита (Чайковского 22) ',
        assetType: 'Абонент',
        address: 'г. Чита, ул. Чайковского, д. 22',
        active: true,
        description: 'Описание 143',
        id: 142,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-17А (Кадала)',
        assetType: 'Абонент',
        address: 'г. Чита, мкр. ТУСМ-4 ТРП-17А Кадала',
        active: false,
        description: 'Описание 144',
        id: 143,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-14Б (Бирюсинск)',
        assetType: 'Абонент',
        address: 'Иркутская обл., г. Бирюсинск, ул. Дружбы, д. 1',
        active: true,
        description: 'Описание 145',
        id: 144,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Иркутск»',
        assetType: 'Абонент',
        address: 'Иркутск, ул. Горького, 15',
        active: false,
        description: 'Описание 146',
        id: 145,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Абонент',
        address: 'Иркутск, 4-я Советская , д.1',
        active: true,
        description: 'Описание 147',
        id: 146,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Иркутск (ул.2-я Железнодорожная,68)',
        assetType: 'Абонент',
        address: 'г. Иркутск, ул. 2-я Железнодорожная, д. 68',
        active: false,
        description: 'Описание 148',
        id: 147,
        сharacteristics: [
          {
            name: 'Тип подключения',
            values: ['Оптоволокно', 'Телевидение', 'Домашний телефон'],
            selectedValue: null
          },
          {
            name: 'Расположение',
            values: ['Частный дом', 'Многоквартирный дом'],
            selectedValue: null
          },
          {
            name: 'ФЛ/ЮЛ',
            values: ['Физическое лицо', 'Юридическое лицо'],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-15М (Мегет)',
        assetType: 'Подстанция',
        address: 'Иркутская обл., п. Мегет, ул. Садовая, д. 27а',
        active: true,
        description: 'Описание 149',
        id: 148,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-12 (Анжеро-Судженск)',
        assetType: 'Подстанция',
        address:
          'Кемеровская область, г. Анжеро-Судженск, ул. Куйбышева, д. 92Б',
        active: false,
        description: 'Описание 150',
        id: 149,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Кузбасс»',
        assetType: 'Подстанция',
        address: 'Кемерово ул. Телецентр, 3',
        active: true,
        description: 'Описание 151',
        id: 150,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Кемерово, ул.Телецентр, 5',
        active: false,
        description: 'Описание 152',
        id: 151,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"СК ""Арена"""',
        assetType: 'Подстанция',
        address: 'Кемерово, ул. Гагагрина, 124',
        active: true,
        description: 'Описание 153',
        id: 152,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД  Кемерово (Ленина 64а)',
        assetType: 'Подстанция',
        address: 'г. Кемерово, пр. Ленина, 64а',
        active: false,
        description: 'Описание 154',
        id: 153,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Кемерово АТС-35 (Октябрьский пр-т 53/1)',
        assetType: 'Подстанция',
        address: 'г. Кемерово, АТС-35, Октябрьский пр-т, 53/1',
        active: true,
        description: 'Описание 155',
        id: 154,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Новокузнецк, ул. Черемнова, 82',
        active: false,
        description: 'Описание 156',
        id: 155,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-321 Новокузнецк(пр. Курако, 39)',
        assetType: 'Подстанция',
        address: 'г. Новокузнецк, пр. Курако, д. 39',
        active: true,
        description: 'Описание 157',
        id: 156,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-32Н (Новокузнецкая)',
        assetType: 'Подстанция',
        address:
          'Кемеровская область, г. Прокопьевск, ул. 2-ая Квартальная, 17, ТРП-32Н, Новокузнецкая',
        active: false,
        description: 'Описание 158',
        id: 157,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Хакасия»',
        assetType: 'Подстанция',
        address: 'Абакан, ул. Вяткина, 12',
        active: true,
        description: 'Описание 159',
        id: 158,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Абакан (Советская 45)',
        assetType: 'Подстанция',
        address: 'г. Абакан, ул. Советская, д. 45',
        active: false,
        description: 'Описание 160',
        id: 159,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-33А (Абакан)',
        assetType: 'Подстанция',
        address: 'г. Абакан, ТРП-33',
        active: true,
        description: 'Описание 161',
        id: 160,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Красноярск»',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Советская, 128',
        active: false,
        description: 'Описание 162',
        id: 161,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Боткина 61',
        active: true,
        description: 'Описание 163',
        id: 162,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Арена Енисей (Футбольный манеж)',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Новгородская, 5, стр.7',
        active: false,
        description: 'Описание 164',
        id: 163,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Кластер МФК «Сопка»',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Биатлонная, 26 Б',
        active: true,
        description: 'Описание 165',
        id: 164,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"АНО ""Арена-Север"" (баскетбол, воллейбол)"',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. 9 мая, д. 74',
        active: false,
        description: 'Описание 166',
        id: 165,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"""Платинум Арена"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Лесников,  д.21',
        active: true,
        description: 'Описание 167',
        id: 166,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ДС им. Ярыгина',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Остров Отдыха, д.12 ',
        active: false,
        description: 'Описание 168',
        id: 167,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Стадион «Авангард» ',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Академика Павлова, д. 21/1',
        active: true,
        description: 'Описание 169',
        id: 168,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Стадион «Центральный»',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Остров Отдыха, д.15а',
        active: false,
        description: 'Описание 170',
        id: 169,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ДС им. М. Дворкина',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Остров Отдыха, д.15',
        active: true,
        description: 'Описание 171',
        id: 170,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Красный Яр"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Маерчака, 57',
        active: false,
        description: 'Описание 172',
        id: 171,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Академия биатлона"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Биатлонная, 37',
        active: true,
        description: 'Описание 173',
        id: 172,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ЛД ""Кристалл Арена"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул . Партизана Железняка, 42',
        active: false,
        description: 'Описание 174',
        id: 173,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Спорт Комплекс ""Радуга"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Елены Стасовой, 62л',
        active: true,
        description: 'Описание 175',
        id: 174,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ДС Стадион ""Енисей"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Юности, 18',
        active: false,
        description: 'Описание 176',
        id: 175,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Горнолыжный комплекс ""Бобровый лог"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Сибирская, 96',
        active: true,
        description: 'Описание 177',
        id: 176,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Первомайский"""',
        assetType: 'Подстанция',
        address: 'Красноярск, ул. Парковая, 19',
        active: false,
        description: 'Описание 178',
        id: 177,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Красноярск (ул.Маркса д.80)',
        assetType: 'Подстанция',
        address: 'г. Красноярск, ул. Карла Маркса, д. 80',
        active: true,
        description: 'Описание 179',
        id: 178,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-13Е (Емельяново)',
        assetType: 'Подстанция',
        address: 'Красноярский край, пгт. Емельяново, ул. Комарова, д. 3А',
        active: false,
        description: 'Описание 180',
        id: 179,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Тыва»',
        assetType: 'Подстанция',
        address: 'Кызыл, ул. Горная, 31',
        active: true,
        description: 'Описание 181',
        id: 180,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Кызыл, ул. Островского, 2,',
        active: false,
        description: 'Описание 182',
        id: 181,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Кызыл (ул.Дружбы д.156)',
        assetType: 'Подстанция',
        address: 'г. Кызыл, ул. Дружбы, д. 156',
        active: true,
        description: 'Описание 183',
        id: 182,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ГПКС/ЦКС ""Железногорск"""',
        assetType: 'Подстанция',
        address: 'Красноярский край, г. Железногорск,  ул. Красноярская 4а',
        active: false,
        description: 'Описание 184',
        id: 183,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Новосибирск»',
        assetType: 'Подстанция',
        address: 'Новосибирск, ул. Римского-Корсакова, 9',
        active: true,
        description: 'Описание 185',
        id: 184,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: ' Новосибирск, ул. Римского-Корсакова 9\\1',
        active: false,
        description: 'Описание 186',
        id: 185,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'КСК «Сибирь» (хоккей)',
        assetType: 'Подстанция',
        address: 'Новосибирск, ул.Б. Хмельницкого, д. 23',
        active: true,
        description: 'Описание 187',
        id: 186,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Новосибирск (Орджоникидзе, 18)',
        assetType: 'Подстанция',
        address: 'г. Новосибирск, ул. Орджоникидзе, 18',
        active: false,
        description: 'Описание 188',
        id: 187,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Новосибирск (2-я Союза Молодежи, д.33/1)',
        assetType: 'Подстанция',
        address: 'г. Новосибирск, ул. 2-я Союза Молодежи, д.33/1',
        active: true,
        description: 'Описание 189',
        id: 188,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-10 (Коченево)',
        assetType: 'Подстанция',
        address: 'Новосибирская обл., р.п. Коченево,ул. Юбилейная, д. 8',
        active: false,
        description: 'Описание 190',
        id: 189,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК/ГУП «ОТС»',
        assetType: 'Подстанция',
        address: 'Новосибирск, ул. Римского-Корсакова, д.22',
        active: true,
        description: 'Описание 191',
        id: 190,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Новосибирск Арена ',
        assetType: 'Подстанция',
        address: 'Новосибирск, Немировича-Данченко, 160',
        active: false,
        description: 'Описание 192',
        id: 191,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Омск (ул.10 лет Октября)',
        assetType: 'Подстанция',
        address: 'Омская область, г. Омск, ул. 10 лет Октября, д. 201',
        active: true,
        description: 'Описание 193',
        id: 192,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Иртыш»',
        assetType: 'Подстанция',
        address: 'Омск, пр. Мира, 2',
        active: false,
        description: 'Описание 194',
        id: 193,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Омск, просп Мира, д.2,',
        active: true,
        description: 'Описание 195',
        id: 194,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'СК «Арена-Омск» (хоккей, в процессе реконструкции)',
        assetType: 'Подстанция',
        address: 'Омск,  ул. Лукашевича, 35',
        active: false,
        description: 'Описание 196',
        id: 195,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-9К (Кормиловка)',
        assetType: 'Подстанция',
        address: 'Омская область, р.п. Кормиловка, ул. Пацаева, д. 36',
        active: true,
        description: 'Описание 197',
        id: 196,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-9С (Таврическая)',
        assetType: 'Подстанция',
        address: 'Омская область, р.п. Таврическое, ',
        active: false,
        description: 'Описание 198',
        id: 197,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ТРК 12 ""канал"""',
        assetType: 'Подстанция',
        address: 'Омск, пр-т Королева, д. 1',
        active: true,
        description: 'Описание 199',
        id: 198,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Томск»',
        assetType: 'Подстанция',
        address: 'Томск, ул. Яковлева, 5',
        active: false,
        description: 'Описание 200',
        id: 199,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Томск, ул.Больничная 11 а',
        active: true,
        description: 'Описание 201',
        id: 200,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Томск (проспект Фрунзе, д. 83а)',
        assetType: 'Подстанция',
        address: 'Томская обл., г. Томск, проспект Фрунзе, д. 83а',
        active: false,
        description: 'Описание 202',
        id: 201,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Урал»',
        assetType: 'Подстанция',
        address: 'Екатеринбург, ул. Луначарского, д.212',
        active: true,
        description: 'Описание 203',
        id: 202,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Екатеринбург, ул. Гурзуфская, 12а',
        active: false,
        description: 'Описание 204',
        id: 203,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'КРК «Уралец» (КХЛ)',
        assetType: 'Подстанция',
        address: 'Екатеринберг, Большакова, д.90',
        active: true,
        description: 'Описание 205',
        id: 204,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""СКБ Банк-Арена Уралмаш"" (РФПЛ)"',
        assetType: 'Подстанция',
        address: 'Екатеринбург,  ул.Репина, д.5',
        active: false,
        description: 'Описание 206',
        id: 205,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"',
        assetType: 'Подстанция',
        address: 'г. Екатеринбург, пер. Асбестовский, 4-а',
        active: true,
        description: 'Описание 207',
        id: 207,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Административное здание',
        assetType: 'Подстанция',
        address: 'Нижний Тагил ул. Пархоменко д. 1а комн. 142',
        active: false,
        description: 'Описание 208',
        id: 208,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Нижний Тагил (Пархоменко 1а)',
        assetType: 'Подстанция',
        address: 'г. Нижний Тагил, ул. Пархоменко, д.1а, комната 142 ',
        active: true,
        description: 'Описание 209',
        id: 209,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-7 (Щелкун)',
        assetType: 'Подстанция',
        address:
          'Свердловская обл., Сысертский р-н, с. Щелкун ул. Гагарина д.10',
        active: false,
        description: 'Описание 210',
        id: 210,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ДИВС (Дворец игровых видов спорта)',
        assetType: 'Подстанция',
        address: 'г. Екатеринбург, Олимпийская набережная, 3',
        active: true,
        description: 'Описание 211',
        id: 211,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК «Областное телевидение» (ОТВ)',
        assetType: 'Подстанция',
        address: 'г. Екатеринбург, ул.Карла Либкнехта, д.22',
        active: false,
        description: 'Описание 212',
        id: 212,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Пермь»',
        assetType: 'Подстанция',
        address: 'Пермь, ул. Техническая, д.7',
        active: true,
        description: 'Описание 213',
        id: 213,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Пермь, ул. Крупской, 61а,',
        active: false,
        description: 'Описание 214',
        id: 214,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"УДС ""Молот"" (баскетбол, воллейбол, гандбол)"',
        assetType: 'Подстанция',
        address: 'Пермь,  ул.Лебедева, д.13',
        active: true,
        description: 'Описание 215',
        id: 215,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Пермь (ул. Крупской 2)',
        assetType: 'Подстанция',
        address: 'г. Пермь, ул. Крупской, д. 2',
        active: false,
        description: 'Описание 216',
        id: 216,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Курган»',
        assetType: 'Подстанция',
        address: 'Курган, ул. Гоголя д. 25',
        active: true,
        description: 'Описание 217',
        id: 217,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД-811 Курган (ул. Бажова 12)',
        assetType: 'Подстанция',
        address: 'г. Курган, ул. Бажова, д. 12',
        active: false,
        description: 'Описание 218',
        id: 218,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-8/41 Варгаши',
        assetType: 'Подстанция',
        address: 'Курганская область, рп. Варгаши, ул. Гайдара, д.53',
        active: true,
        description: 'Описание 219',
        id: 219,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-8С Беркут',
        assetType: 'Подстанция',
        address: 'Тюменская область, ТРП-8С Беркут 56.711436, 66.087305',
        active: false,
        description: 'Описание 220',
        id: 220,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Регион-Тюмень»',
        assetType: 'Подстанция',
        address: 'Тюмень, ул. Пермякова, д. 6, к. 70 ',
        active: true,
        description: 'Описание 221',
        id: 221,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Тюмень, ул. Пермякова, 3 а',
        active: false,
        description: 'Описание 222',
        id: 222,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Геолог"" (футбол)"',
        assetType: 'Подстанция',
        address: 'Тюмень, ул.Коммуны, д.22',
        active: true,
        description: 'Описание 223',
        id: 223,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"СК ""Центральный"" (футбол)"',
        assetType: 'Подстанция',
        address: 'Тюмень, ул.Орджоникидзе, д.60/1',
        active: false,
        description: 'Описание 224',
        id: 224,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Тюмень (ул. Республики 51)',
        assetType: 'Подстанция',
        address: 'г. Тюмень, ул. Республики, д. 51',
        active: true,
        description: 'Описание 225',
        id: 225,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-8А (Ялуторовск)',
        assetType: 'Подстанция',
        address: 'Тюменская область, г. Ялуторовск, ул. 40 лет октября, д. 1',
        active: false,
        description: 'Описание 226',
        id: 226,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: ' Биатлонный комплекс Жемчужина Сибири',
        assetType: 'Подстанция',
        address:
          'Тюменская область, Тюменский район, 45 км автомобильной дороги «Богандинский-Червишево-Чаплык», строение 22',
        active: true,
        description: 'Описание 227',
        id: 227,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Югория»',
        assetType: 'Подстанция',
        address: 'Ханты-Мансийск, ул. Гагарина, д.4',
        active: false,
        description: 'Описание 228',
        id: 228,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'КРК «Арена-Югра» (хоккей)',
        assetType: 'Подстанция',
        address: 'Ханты-Мансийск,  ул.Ледовая, д.1А',
        active: true,
        description: 'Описание 229',
        id: 229,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ЦЗВС им. А.В. ФИЛИПЕНКО',
        assetType: 'Подстанция',
        address: 'Ханты-Мансийск, ул. Спортивная, 15',
        active: false,
        description: 'Описание 230',
        id: 230,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Центр развития теннисного спорта',
        assetType: 'Подстанция',
        address: 'Ханты-Мансийск, ул.Студенческая, д.21',
        active: true,
        description: 'Описание 231',
        id: 231,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Ханты-Мансийск ( ул. Садовая 15)',
        assetType: 'Подстанция',
        address: 'г. Ханты-Мансийск, ул. Садовая, 15',
        active: false,
        description: 'Описание 232',
        id: 232,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Ханты-Мансийск (Мира, 4 )',
        assetType: 'Подстанция',
        address: 'г. Ханты-Мансийск, ул. Мира, 4 ',
        active: true,
        description: 'Описание 233',
        id: 233,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УСК «Арена Металлург» (хоккей)',
        assetType: 'Подстанция',
        address: 'Магнитогорск, проспект Ленина, д.105',
        active: false,
        description: 'Описание 234',
        id: 234,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Магнитогорск (Ленина, д.32/1)',
        assetType: 'Подстанция',
        address: 'г. Магнитогорск, ул.Ленина, д.32/1',
        active: true,
        description: 'Описание 235',
        id: 235,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-6- Опытное',
        assetType: 'Подстанция',
        address:
          'Челябинская область, п. Тимирязевский, ул. Чайковского, д. 32',
        active: false,
        description: 'Описание 236',
        id: 236,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Южный Урал»',
        assetType: 'Подстанция',
        address: 'Челябинск, ул. Орджоникидзе, д.54-Б',
        active: true,
        description: 'Описание 237',
        id: 237,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Челябинск, ул. Орджоникидзе 54 в',
        active: false,
        description: 'Описание 238',
        id: 238,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ЛД «Трактор» (хоккей)',
        assetType: 'Подстанция',
        address: 'Челябинск, ул. 250 лет Челябинска, 38',
        active: true,
        description: 'Описание 239',
        id: 239,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Челябинск (ул. Воровского 71)',
        assetType: 'Подстанция',
        address: 'г. Челябинск, ул. Воровского, 71',
        active: false,
        description: 'Описание 240',
        id: 240,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК «ММК «ТВ-ИН»',
        assetType: 'Подстанция',
        address: 'Челябинская обл. г. Магнитогорск, ул.Ленина, 124/1',
        active: true,
        description: 'Описание 241',
        id: 241,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРК. ГПЧО «Обл-ТВ»',
        assetType: 'Подстанция',
        address: 'Челябинск, Площадь революции, д.4',
        active: false,
        description: 'Описание 242',
        id: 242,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '«Дворец Спорта Звездный» (воллейбол)',
        assetType: 'Подстанция',
        address:
          'Ямало-Ненецкий автономный округ, Новый Уренгой, Олимпийский д.1',
        active: true,
        description: 'Описание 243',
        id: 243,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Ямал»',
        assetType: 'Подстанция',
        address: 'Салехард, ул. Зои Космодемьянской, 75',
        active: false,
        description: 'Описание 244',
        id: 244,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Салехард (ул. Матросова 2)',
        assetType: 'Подстанция',
        address: 'г. Салехард, ул. Матросова, д. 2',
        active: true,
        description: 'Описание 245',
        id: 245,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Белгород»',
        assetType: 'Подстанция',
        address: 'Белгород,  Проспект Славы, дом 60 ',
        active: false,
        description: 'Описание 246',
        id: 246,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Белгород, ул. Мокроусова 6',
        active: true,
        description: 'Описание 247',
        id: 247,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ДК ""Арена Космос"""',
        assetType: 'Подстанция',
        address: 'Белгород, ул. Королева, 5',
        active: false,
        description: 'Описание 248',
        id: 248,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-371 Белгород  (пр.Б.Хмельницкого 81)',
        assetType: 'Подстанция',
        address: 'г. Белгород, пр-т Б. Хмельницкого, д. 81',
        active: true,
        description: 'Описание 249',
        id: 249,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Воронеж»',
        assetType: 'Подстанция',
        address: 'Воронеж, ул. Карла Маркса, д. 114',
        active: false,
        description: 'Описание 250',
        id: 250,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Подстанция',
        address: 'Воронеж, ул. Карла Маркса, д.114В',
        active: true,
        description: 'Описание 251',
        id: 251,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Воронеж МСС-361 (пр. Революции, 35)',
        assetType: 'Подстанция',
        address: 'г. Воронеж, пр. Революции, д. 35',
        active: false,
        description: 'Описание 252',
        id: 252,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Калуга»',
        assetType: 'Подстанция',
        address: 'Калуга, ул. Поле Свободы д. 40-А',
        active: true,
        description: 'Описание 253',
        id: 253,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-311 Калуга (ул.Театральная, 38)',
        assetType: 'Подстанция',
        address: 'г. Калуга, ул. Театральная, д. 38',
        active: false,
        description: 'Описание 254',
        id: 254,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-34М (Медвенка)',
        assetType: 'Подстанция',
        address: 'Курская обл., п. Медвенка, ул. Парковая, д. 11',
        active: true,
        description: 'Описание 255',
        id: 255,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Курск»',
        assetType: 'Подстанция',
        address: 'Курск, ул. Советская ул., 32 ',
        active: false,
        description: 'Описание 256',
        id: 256,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Курск (ул.Радищева, 26)',
        assetType: 'Подстанция',
        address: 'г. Курск, ул. Радищева, д. 26',
        active: true,
        description: 'Описание 257',
        id: 257,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-2з (Задонск)',
        assetType: 'Подстанция',
        address: 'Липецкая обл., г. Задонск, ул. К. Маркса, д. 2г',
        active: false,
        description: 'Описание 258',
        id: 258,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Липецк»',
        assetType: 'Подстанция',
        address: 'Липецк, пл. Плеханова, д. 1',
        active: true,
        description: 'Описание 259',
        id: 259,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-351 Липецк (ул. Плеханова, 5)',
        assetType: 'Подстанция',
        address: 'г. Липецк, ул. Плеханова, д. 5',
        active: false,
        description: 'Описание 260',
        id: 260,
        сharacteristics: [
          {
            name: 'Частота',
            values: [
              'Частота 1',
              'Частота 2',
              'Частота 3',
              'Частота 4',
              'Частота 5',
              'Частота 6',
              'Частота 7',
              'Частота 8',
              'Частота 9'
            ],
            selectedValue: null
          },
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ВТБ Арена, СРК ""Парк Легенд"""',
        assetType: 'Узел',
        address: 'Москва, ул.Автозаводская, вл.23, КХЛ хоккей',
        active: true,
        description: 'Описание 261',
        id: 261,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ВТБ Арена',
        assetType: 'Узел',
        address: 'Москва,  Ленинградский проспект, д.36, футбол, хоккей',
        active: false,
        description: 'Описание 262',
        id: 262,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Большая спортивная арена ""Лужники"""',
        assetType: 'Узел',
        address: 'Москва, Лужнецкая наб., д.24, стр.1, футбол',
        active: true,
        description: 'Описание 263',
        id: 263,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Малая спортивная арена ""Лужники"""',
        assetType: 'Узел',
        address: 'Москва, Москва, ул.Лужники, д.24',
        active: false,
        description: 'Описание 264',
        id: 264,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Динамо"""',
        assetType: 'Узел',
        address: 'Москва, Ленинградский проспект, д.36',
        active: true,
        description: 'Описание 265',
        id: 265,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""ВЭБ-Арена"',
        assetType: 'Узел',
        address: 'Москва, ул. 3-я Песчаная, д.2А, РФПЛ футбол',
        active: false,
        description: 'Описание 266',
        id: 266,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""РЖД-Арена"""',
        assetType: 'Узел',
        address:
          'Москва, ул. Большая Черкизовская, д.125 строение 1, РФПЛ футбол.',
        active: true,
        description: 'Описание 267',
        id: 267,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Открытие Арена"""',
        assetType: 'Узел',
        address: 'Москва, Волоколамское шоссе, д.69, РФПЛ футбол',
        active: false,
        description: 'Описание 268',
        id: 268,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД М10 Москва',
        assetType: 'Узел',
        address: 'г. Москва Сущёвский вал, д.26',
        active: true,
        description: 'Описание 269',
        id: 269,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-11 (М-9) Москва',
        assetType: 'Узел',
        address: 'г. Москва, ул. Бутлерова, д.7',
        active: false,
        description: 'Описание 270',
        id: 270,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Ледовый дворец им. Ю.Е. Ляпкина',
        assetType: 'Узел',
        address: 'Московская обл,  Балашиха, ул. Парковая, д.2',
        active: true,
        description: 'Описание 271',
        id: 271,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Красногорск. Крокус Экспо',
        assetType: 'Узел',
        address:
          'Московская область, Красногорск, ул.Международная, д.20 помещение АТС',
        active: false,
        description: 'Описание 272',
        id: 272,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Ледовый дворец ""Арена-Мытищи"""',
        assetType: 'Узел',
        address: 'Московская обл,  Мытищи, ул. Лётная, д.17',
        active: true,
        description: 'Описание 273',
        id: 273,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ЛД ""Витязь"""',
        assetType: 'Узел',
        address: 'Московская область , Подольск, ул.Кирова, д.63а',
        active: false,
        description: 'Описание 274',
        id: 274,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Химки. Арена ""Химки"", ул.Кирова, д.24, РФПЛ футбол"',
        assetType: 'Узел',
        address: 'Московская, область,  Химки, ул.Кирова, д.24, РФПЛ футбол',
        active: true,
        description: 'Описание 275',
        id: 275,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Химки. ""Арена БЦМО"" (Баскетбольный центр)"',
        assetType: 'Узел',
        address:
          'Московская, область,  Химки, ул. Кирова, вл. 27, Лига ВТБ баскетбол',
        active: false,
        description: 'Описание 276',
        id: 276,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Шелудьково. Moscow RaceWay',
        assetType: 'Узел',
        address: '"Московская область, дер.""Шелудьково"", автогонки"',
        active: true,
        description: 'Описание 277',
        id: 277,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-1 (Ногинск)',
        assetType: 'Узел',
        address:
          'Богородский городской округ, Московская область, г. Ногинск, ул. Октябрьская, д. 96',
        active: false,
        description: 'Описание 278',
        id: 278,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Смоленск»',
        assetType: 'Узел',
        address: 'Смоленск, ул. Дзержинского д. 17 ',
        active: true,
        description: 'Описание 279',
        id: 279,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Узел',
        address: 'Смоленск,ул. Октябрьской революции, д. 6а',
        active: false,
        description: 'Описание 280',
        id: 280,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Смоленск ОПТС (ул. Нормандия-Неман, 25)',
        assetType: 'Узел',
        address: 'г. Смоленск, ул. Нормандия-Неман, д.25',
        active: true,
        description: 'Описание 281',
        id: 281,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-39Я (Ярцево)',
        assetType: 'Узел',
        address: 'Смоленская обл. г. Ярцево, ул. Халтурина, д.16',
        active: false,
        description: 'Описание 282',
        id: 282,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Тамбов»',
        assetType: 'Узел',
        address: 'Тамбов, ул.Мичуринская,д.8-а',
        active: true,
        description: 'Описание 283',
        id: 283,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Тамбов (ул.Советская 36)',
        assetType: 'Узел',
        address: 'г. Тамбов, ул. Советская, д. 36',
        active: false,
        description: 'Описание 284',
        id: 284,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Тверь»',
        assetType: 'Узел',
        address: 'Тверь, ул. Вагжанова, д. 9',
        active: true,
        description: 'Описание 285',
        id: 285,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Узел',
        address: 'Тверь , ул. Вокзальная дом 10/1',
        active: false,
        description: 'Описание 286',
        id: 286,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-261 Тверь (ул. Симеоновская 28)',
        assetType: 'Узел',
        address: 'г. Тверь, ул. Симеоновская, д. 28',
        active: true,
        description: 'Описание 287',
        id: 287,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Брянск»',
        assetType: 'Узел',
        address: 'Брянск, пр. Станке Димитрова, 77',
        active: false,
        description: 'Описание 288',
        id: 288,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-331 Брянск  (пр. Ленина 47)',
        assetType: 'Узел',
        address: 'г. Брянск, пр. Ленина, д. 47',
        active: true,
        description: 'Описание 289',
        id: 289,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-32К (Кромы)',
        assetType: 'Узел',
        address: 'Орловская обл., пгт. Кромы, ул. К. Маркса, д. 83',
        active: false,
        description: 'Описание 290',
        id: 290,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-33Г (Глинищево)',
        assetType: 'Узел',
        address: 'Брянская обл., с. Глинищево, ул. Связистов, д. 1',
        active: true,
        description: 'Описание 291',
        id: 291,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Орел»',
        assetType: 'Узел',
        address: 'Орел, ул. 7-го Ноября, д. 43',
        active: false,
        description: 'Описание 292',
        id: 292,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"""Грин-Центр"" (мобильный комплект из МСК)"',
        assetType: 'Узел',
        address: 'Орел, Кромское шоссе, 4',
        active: true,
        description: 'Описание 293',
        id: 293,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Орёл АТС-77 (Авиационная, 3)',
        assetType: 'Узел',
        address: 'г. Орел, ул. Авиационная, д. 3',
        active: false,
        description: 'Описание 294',
        id: 294,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-31Д (Дубна)',
        assetType: 'Узел',
        address: 'г. Дубна, ТРП-31Д',
        active: true,
        description: 'Описание 295',
        id: 295,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-23С (Собчаково)',
        assetType: 'Узел',
        address: 'Рязанская обл., село Собчаково, ул. Спасская, д. 1',
        active: false,
        description: 'Описание 296',
        id: 296,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Ока»',
        assetType: 'Узел',
        address: 'Рязань, ул.Скоморошинская д.20',
        active: true,
        description: 'Описание 297',
        id: 297,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-231 Рязань (ул. Свободы, 36)',
        assetType: 'Узел',
        address: 'г. Рязань, ул. Свободы, д. 36',
        active: false,
        description: 'Описание 298',
        id: 298,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-2 (С. Клёпики)',
        assetType: 'Узел',
        address: 'Рязанская область, г. Спас-Клепики, ул. Ленина, д.90А ТРП-2',
        active: true,
        description: 'Описание 299',
        id: 299,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Тула»',
        assetType: 'Узел',
        address: 'Тула, ул. Староникитская, д. 1',
        active: false,
        description: 'Описание 300',
        id: 300,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Узел',
        address: 'Тула, ул. Скуратовская, д.141',
        active: true,
        description: 'Описание 301',
        id: 301,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Арсенал"" (Футбол)"',
        assetType: 'Узел',
        address: 'Тула, проспект.Ленина, д. 87',
        active: false,
        description: 'Описание 302',
        id: 302,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-241 Тула (пр. Ленина, 33)',
        assetType: 'Узел',
        address: 'г. Тула, пр. Ленина, д. 33',
        active: true,
        description: 'Описание 303',
        id: 303,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Богородицк ТРП-24Б',
        assetType: 'Узел',
        address:
          'Тульская обл., р-н. Богородицкий, д. Упертовка, ул. Липки, д.5, ТРП-24Б',
        active: false,
        description: 'Описание 304',
        id: 304,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Кострома»',
        assetType: 'Узел',
        address: 'Кострома, пл. Конституции, д. 1',
        active: true,
        description: 'Описание 305',
        id: 305,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Кострома (Подлипаева. 1)',
        assetType: 'Узел',
        address: 'г. Кострома, ул. Подлипаева, д. 1',
        active: false,
        description: 'Описание 306',
        id: 306,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Ярославия»',
        assetType: 'Узел',
        address: 'Ярославль, ул. Богдановича, д.20  (Дом радио)',
        active: true,
        description: 'Описание 307',
        id: 307,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Узел',
        address: 'Ярославль, ул. Володарского, 48',
        active: false,
        description: 'Описание 308',
        id: 308,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УКСК «Арена-2000-Локомотив» (хоккей)',
        assetType: 'Узел',
        address: 'Ярославль, ул.Гагарина, д.15',
        active: true,
        description: 'Описание 309',
        id: 309,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-172Я Ярославль (ул. Володарского, д.48)',
        assetType: 'Узел',
        address: 'г. Ярославль, ул. Володарского, д.48',
        active: false,
        description: 'Описание 310',
        id: 310,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ТРК/ТК ""Первый Ярославский"""',
        assetType: 'Узел',
        address: 'Ярославль,  ул.Советская, 69',
        active: true,
        description: 'Описание 311',
        id: 311,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Владимир»',
        assetType: 'Узел',
        address: 'Владимир, ул. Большая Московская, д. 62',
        active: false,
        description: 'Описание 312',
        id: 312,
        сharacteristics: [
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Удаленность',
            values: [
              'Удаленность 1',
              'Удаленность 2',
              'Удаленность 3',
              'Удаленность 4',
              'Удаленность 5',
              'Удаленность 6',
              'Удаленность 7',
              'Удаленность 8',
              'Удаленность 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Приемник',
        address: 'Владимир, ул. Березина, д. 2-Б',
        active: true,
        description: 'Описание 313',
        id: 313,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: ' МСС-13 Владимир (ул. Гороховая, 20)',
        assetType: 'Приемник',
        address: 'г. Владимир, ул. Гороховая, д. 20',
        active: false,
        description: 'Описание 314',
        id: 314,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Станционный участок  технический цех 156 (Гатиха)',
        assetType: 'Приемник',
        address: 'Владимирская обл Камешковский р-н, с. Гатиха д.19Д ',
        active: true,
        description: 'Описание 315',
        id: 315,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Ивтелерадио»',
        assetType: 'Приемник',
        address: 'Иваново, ул. Театральная д. 31',
        active: false,
        description: 'Описание 316',
        id: 316,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Иваново (ул.10-го Августа, 1)',
        assetType: 'Приемник',
        address: 'г. Иваново, ул. 10-го Августа, д. 1',
        active: true,
        description: 'Описание 317',
        id: 317,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-18Т (Тейково)',
        assetType: 'Приемник',
        address: 'Ивановская область, г. Тейково, ул. Першинская, д. 48А',
        active: false,
        description: 'Описание 318',
        id: 318,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Лотос»',
        assetType: 'Приемник',
        address: 'Астрахань, ул. Ляхова, д.4',
        active: true,
        description: 'Описание 319',
        id: 319,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"СК ""Звездный"""',
        assetType: 'Приемник',
        address: 'Астрахань, ул. Николая Островского, д. 147',
        active: false,
        description: 'Описание 320',
        id: 320,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'МСС-181 (Астрахань)',
        assetType: 'Приемник',
        address: 'г. Астрахань, ул. Чернышевского, д. 10-25',
        active: true,
        description: 'Описание 321',
        id: 321,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Вайнах»',
        assetType: 'Приемник',
        address: 'Грозный, ул. Абузара Айдамирова, 147, корп.5',
        active: false,
        description: 'Описание 322',
        id: 322,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Грозный (Лорсанова 21)',
        assetType: 'Приемник',
        address: 'Чеченская Республика, г. Грозный, ул. Лорсанова, д. 21',
        active: true,
        description: 'Описание 323',
        id: 323,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Волгоград-ТРВ»',
        assetType: 'Приемник',
        address: 'Волгоград, ул.им.Рокоссовского, д.100 ',
        active: false,
        description: 'Описание 324',
        id: 324,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Приемник',
        address: 'Волгоград, ул Рокоссовского 98',
        active: true,
        description: 'Описание 325',
        id: 325,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Волгоград (Мира, 16)',
        assetType: 'Приемник',
        address: 'г. Волгоград, ул. Мира, д. 16',
        active: false,
        description: 'Описание 326',
        id: 326,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-21.2 (Кизляр)',
        assetType: 'Приемник',
        address: 'Ремпублика дагестан, г. Кизляр, ул. Строительная, д. 3',
        active: true,
        description: 'Описание 327',
        id: 327,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Дагестан»',
        assetType: 'Приемник',
        address: 'Махачкала, улица Магомета Гаджиева, 182',
        active: false,
        description: 'Описание 328',
        id: 328,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Махачкала (ул. Р.Гамзатова, 3)',
        assetType: 'Приемник',
        address: 'г. Махачкала, проспект Р. Гамзатова, д. 3',
        active: true,
        description: 'Описание 329',
        id: 329,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ГТРК ""Донецк"""',
        assetType: 'Приемник',
        address: 'Донецк, ул. Куйбышева, д. 61',
        active: false,
        description: 'Описание 330',
        id: 330,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Ингушетия»',
        assetType: 'Приемник',
        address: 'Республика Ингушетия, Назрань, пер. Набережный, д. 8',
        active: true,
        description: 'Описание 331',
        id: 331,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Назрань (ул. Московская, 20)',
        assetType: 'Приемник',
        address: 'Республика Ингушетия, г. Назрань, ул. Московская, д. 20',
        active: false,
        description: 'Описание 332',
        id: 332,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Кабардино-Балкария»',
        assetType: 'Приемник',
        address: 'Кабардино-Балкарская Республика, Нальчик, проспект Ленина,1А',
        active: true,
        description: 'Описание 333',
        id: 333,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Нальчик (ул.Кулиева, 14)',
        assetType: 'Приемник',
        address:
          'Кабардино-Балкарская Республика, г. Нальчик, ул. Кулиева, д. 14',
        active: false,
        description: 'Описание 334',
        id: 334,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Калмыкия» ',
        assetType: 'Приемник',
        address: 'Элиста, ул. М.Горького,34',
        active: true,
        description: 'Описание 335',
        id: 335,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Элиста (Ул. Сусеева, 31)',
        assetType: 'Приемник',
        address: 'г. Элиста, ул. Сусеева, д. 31',
        active: false,
        description: 'Описание 336',
        id: 336,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-15Э (Элиста)',
        assetType: 'Приемник',
        address:
          ' г. Элиста, автодорога Астрахань-Элиста-Ставрополь, 320км+150м (ТРП-15Э)',
        active: true,
        description: 'Описание 337',
        id: 337,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Кубань»',
        assetType: 'Приемник',
        address: 'Краснодар, ул.Радио, д.5',
        active: false,
        description: 'Описание 338',
        id: 338,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Приемник',
        address: 'Краснодар, ул. Радио 3а. Техническое здание, АК-1.',
        active: true,
        description: 'Описание 339',
        id: 339,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Баскет Холл"" (баскетбол)"',
        assetType: 'Приемник',
        address: 'Краснодар, ул. Кубанская набережная, д.62',
        active: false,
        description: 'Описание 340',
        id: 340,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Краснодар"" (футбол)"',
        assetType: 'Приемник',
        address: 'Краснодар, ул.Разведчика Леонова, д.1',
        active: true,
        description: 'Описание 341',
        id: 341,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Краснодар (ул.Красная,59)',
        assetType: 'Приемник',
        address: 'г. Краснодар, ул. Красная, д. 59',
        active: false,
        description: 'Описание 342',
        id: 342,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-5Д (Джубга)',
        assetType: 'Приемник',
        address:
          'Краснодарский край, Туапсинский район, пгт. Джубга, пер. Радио, д. 1',
        active: true,
        description: 'Описание 343',
        id: 343,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-3Б (Р. Несветайская)',
        assetType: 'Приемник',
        address: 'с. Родионово-Несветайская, ул. Мичурина, д. 1',
        active: false,
        description: 'Описание 344',
        id: 344,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-11Н (Новорождественская)',
        assetType: 'Приемник',
        address:
          'Краснодарский край, Тихорецкий район, ст. Новорождественская, ул. Бочарова, д. 115А',
        active: true,
        description: 'Описание 345',
        id: 345,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-12К (Кропоткин)',
        assetType: 'Приемник',
        address: 'Краснодарский край, г. Кропоткин, 129Б',
        active: false,
        description: 'Описание 346',
        id: 346,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Адыгея»',
        assetType: 'Приемник',
        address: 'Майкоп. ул. Жуковского, 24',
        active: true,
        description: 'Описание 347',
        id: 347,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Майкоп (Пионерская, вл. 260)',
        assetType: 'Приемник',
        address: 'Краснодарский край, г. Майкоп, ул. Пионерская, вл. 260',
        active: false,
        description: 'Описание 348',
        id: 348,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'т/о ГТРК «Кубань»',
        assetType: 'Приемник',
        address: 'Сочи, ул.Театральная, 11-А',
        active: true,
        description: 'Описание 349',
        id: 349,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Большая ледовая арена (Большой)',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский проспект, д.7',
        active: false,
        description: 'Описание 350',
        id: 350,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Малая ледовая арена (ЛА ""Шайба"")"',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский просп., 11, п. г. т. Сириус',
        active: true,
        description: 'Описание 351',
        id: 351,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Автодром Сочи',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский парк, Олимпийский проспект, д.1',
        active: false,
        description: 'Описание 352',
        id: 352,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Ледяной Куб',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский парк, Олимпийский проспект, д.2А',
        active: true,
        description: 'Описание 353',
        id: 353,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Главный медиацентр (ГМЦ)',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский парк, Олимпийский проспект, д.1',
        active: false,
        description: 'Описание 354',
        id: 354,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Айсберг',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский просп., с1, п. г. т. Сириус',
        active: true,
        description: 'Описание 355',
        id: 355,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ФИШТ (футбол)',
        assetType: 'Приемник',
        address: 'Сочи, Адлер, Олимпийский просп., 15, п. г. т. Сириус',
        active: false,
        description: 'Описание 356',
        id: 356,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Сочи (Виноградная, 47а)',
        assetType: 'Приемник',
        address: 'г. Сочи, ул. Виноградная, д. 47 А',
        active: true,
        description: 'Описание 357',
        id: 357,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Сочи (Ленина, д.2)',
        assetType: 'Приемник',
        address: 'г. Сочи, ул. Ленина, д.2',
        active: false,
        description: 'Описание 358',
        id: 358,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Дворец спорта «Олимп»',
        assetType: 'Приемник',
        address: 'Краснодар, ул. Береговая, д. 144',
        active: true,
        description: 'Описание 359',
        id: 359,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Роза Хутор',
        assetType: 'Приемник',
        address: 'Сочи, Роза Хутор, Роза Холл',
        active: false,
        description: 'Описание 360',
        id: 360,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'Новая волна',
        assetType: 'Приемник',
        address:
          'Сочи, пр-т Олимпийский,  Сцена Новой Волны в Олимпийском парке',
        active: true,
        description: 'Описание 361',
        id: 361,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Севастополь»',
        assetType: 'Приемник',
        address: 'Севастополь, Фиолентовское шоссе, д.1. ',
        active: false,
        description: 'Описание 362',
        id: 362,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'АО ТРК-3 ГТРК «Таврида»',
        assetType: 'Приемник',
        address: 'Симферополь, ул. Студенческая, 14',
        active: true,
        description: 'Описание 363',
        id: 363,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"ГТРК ""Луганск"""',
        assetType: 'Приемник',
        address: 'Луганск, ул. Демехина, д. 25',
        active: false,
        description: 'Описание 364',
        id: 364,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-3А (Аксай)',
        assetType: 'Приемник',
        address: 'Ростовская область, г. Аксай, пр. Ленина, д. 44',
        active: true,
        description: 'Описание 365',
        id: 365,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Дон-ТР»',
        assetType: 'Приемник',
        address: 'Ростов-на-Дону, ул.1-я Баррикадная, д.18',
        active: false,
        description: 'Описание 366',
        id: 366,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'РТРС',
        assetType: 'Приемник',
        address: 'Ростов-на-Дону, ул. Токарная,д. 11',
        active: true,
        description: 'Описание 367',
        id: 367,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: '"Стадион ""Ростов-Арена"" (футбол)"',
        assetType: 'Приемник',
        address: 'Ростов-на-Дону, ул.Левобережная, д.2Б',
        active: false,
        description: 'Описание 368',
        id: 368,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Ростов-на-Дону (Газетный пер, 49)',
        assetType: 'Приемник',
        address: 'г. Ростов-на-Дону, пер. Газетный, д. 49',
        active: true,
        description: 'Описание 369',
        id: 369,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-20А (Ардон)',
        assetType: 'Приемник',
        address: 'Республика Северная-Осетия, г. Ардон, ул. Алагирская, 33а',
        active: false,
        description: 'Описание 370',
        id: 370,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Алания»',
        assetType: 'Приемник',
        address: 'Владикавказ, ул. Койбаева, д. 83',
        active: true,
        description: 'Описание 371',
        id: 371,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Владикавказ (ул.Кирова, 47)',
        assetType: 'Приемник',
        address: 'г. Владикавказ, ул. Кирова, д. 47',
        active: false,
        description: 'Описание 372',
        id: 372,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРп-14Б (Буденновск)',
        assetType: 'Приемник',
        address: 'Ставропольский край, г. Буденновск, ул. Партизанская, д. 16',
        active: true,
        description: 'Описание 373',
        id: 373,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-12Н (Невинномысск)',
        assetType: 'Приемник',
        address: 'г. Невинномысск, ул. Менделеева, д. 69',
        active: false,
        description: 'Описание 374',
        id: 374,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-13П (Пятигорск)',
        assetType: 'Приемник',
        address: 'г. Пятигорск, пр-т 40 лет Октября, д. 27',
        active: true,
        description: 'Описание 375',
        id: 375,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Ставрополье»',
        assetType: 'Приемник',
        address: 'Ставрополь, ул. Дзержинского, д. 149-151',
        active: false,
        description: 'Описание 376',
        id: 376,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Ставрополь (ул.Мира,290)',
        assetType: 'Приемник',
        address: 'Ставрополь (ул.Мира,290)',
        active: true,
        description: 'Описание 377',
        id: 377,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ТРП-19С (Соломенское)',
        assetType: 'Приемник',
        address: 'Ставропольский край, с. Соломенское, ул. Степная, 1а',
        active: false,
        description: 'Описание 378',
        id: 378,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'ГТРК «Карачаево-Черкесия»',
        assetType: 'Приемник',
        address:
          'Карачаево-Черкесская Республика, Черкесск, ул. Красноармейская, д. 51',
        active: true,
        description: 'Описание 379',
        id: 379,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      },
      {
        assetName: 'УД Черкесск (ул.Первомайская, 30/пер.Союзный 17)',
        assetType: 'Приемник',
        address:
          'Карачаево-Черкесская Республика, г. Черкесск, ул. Первомайская, д. 30 - пер. Союзный, д. 17',
        active: false,
        description: 'Описание 380',
        id: 380,
        сharacteristics: [
          {
            name: 'Модель оборудования',
            values: [
              'Модель 1',
              'Модель 2',
              'Модель 3',
              'Модель 4',
              'Модель 5',
              'Модель 6',
              'Модель 7',
              'Модель 8',
              'Модель 9'
            ],
            selectedValue: null
          },
          {
            name: 'Технология',
            values: [
              'Технология 1',
              'Технология 2',
              'Технология 3',
              'Технология 4',
              'Технология 5',
              'Технология 6',
              'Технология 7',
              'Технология 8',
              'Технология 9'
            ],
            selectedValue: null
          },
          {
            name: 'Мощность',
            values: [
              'Мощность 1',
              'Мощность 2',
              'Мощность 3',
              'Мощность 4',
              'Мощность 5',
              'Мощность 6',
              'Мощность 7',
              'Мощность 8',
              'Мощность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Пропускная способность',
            values: [
              'Пропускная способность 1',
              'Пропускная способность 2',
              'Пропускная способность 3',
              'Пропускная способность 4',
              'Пропускная способность 5',
              'Пропускная способность 6',
              'Пропускная способность 7',
              'Пропускная способность 8',
              'Пропускная способность 9'
            ],
            selectedValue: null
          },
          {
            name: 'Версия ПО',
            values: [
              'Версия 1',
              'Версия 2',
              'Версия 3',
              'Версия 4',
              'Версия 5',
              'Версия 6',
              'Версия 7',
              'Версия 8',
              'Версия 9'
            ],
            selectedValue: null
          }
        ]
      }
    ];
  },

  getObjectsSmall() {
    return Promise.resolve(this.getData().slice(0, 10));
  },

  getObjectsMedium() {
    return Promise.resolve(this.getData().slice(0, 50));
  },

  getObjectsLarge() {
    return Promise.resolve(this.getData().slice(0, 200));
  },

  getObjectsXLarge() {
    return Promise.resolve(this.getData());
  },

  getObjects(params: { [x: string]: string | number | boolean }) {
    const queryParams = params
      ? Object.keys(params)
          .map(
            (k) => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])
          )
          .join('&')
      : '';

    return fetch(
      'https://www.primefaces.org/data/Employees?' + queryParams
    ).then((res) => res.json());
  }
};
